// min.js loads async and can execute before the parser reaches <body> (cached
// script, slow-parse page). Anything that mounts DOM at load — the sandbox
// banner, a pop-on-load paywall — must wait for the body rather than touching
// document.body directly. document.body is null only while readyState is
// 'loading', so a DOMContentLoaded listener registered on a null observation is
// guaranteed to fire.
export function whenBodyReady(): Promise<void> {
  if (document.body) {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    document.addEventListener('DOMContentLoaded', () => resolve(), { once: true });
  });
}
